import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NbCardModule, NbLayoutModule, NbMenuModule, NbSidebarModule, NbUserModule } from '@nebular/theme';
import { ToasterModule } from 'angular2-toaster';
import { ThemeModule } from '../@theme/theme.module';
import { SentryErrorHandler } from '../sentry.service';
import { MarketingTotalsFromCompaniesCalculator } from './calculator/MarketingTotalsFromCompaniesCalculator';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { LeadinHelpComponent } from './directives/leadin-help/leadin-help.component';
import { LeadinHelpDirective } from './directives/leadin-help/leadin-help.directive';
import { ErrorFormatter } from './formatter/error.formatter';
import { MyLeadRouteGenerator } from './generator/mylead-route.generator';
import { PipesModule } from './pipes/pipes.module';
import { CsvGeneratorService } from './services/csv-generation/csv-generator.service';
import { MessagingService } from './services/firebase/messaging.service';
import { LeadService } from './services/lead/lead.service';
import { AuthService } from './services/security/auth.service';
import { UserService } from './services/security/user.service';
import { SidebarManagerService } from './services/utils/sidebar-manager.service';
import { TablesService } from './services/utils/tables.service';
import { ToastService } from './services/utils/toast.service';
import { TranslatorService } from './services/utils/translator.service';
import { CheckForUpdateService } from './services/worker/check-for-update.service';
import { LogUpdateService } from './services/worker/log-update.service';
import { PromptUpdateService } from './services/worker/prompt-update.service';
import { SharedHandlerService } from './shared.handler.service';

@NgModule({
  imports: [
    CommonModule,
    NbCardModule,
    NbMenuModule.forRoot(),
    NbLayoutModule,
    NbSidebarModule,
    NbUserModule,
    ThemeModule,
    PipesModule,
    ToasterModule.forChild()

  ],
  declarations: [LeadinHelpDirective, LeadinHelpComponent, SpinnerComponent, PaginationComponent],
  providers: [
    ToastService,
    MessagingService,
    LogUpdateService,
    PromptUpdateService,
    CheckForUpdateService,
    TranslatorService,
    LeadService,
    CsvGeneratorService,
    ErrorFormatter,
    MyLeadRouteGenerator,
    SentryErrorHandler,
    MarketingTotalsFromCompaniesCalculator,
    SharedHandlerService,
  ],
  exports: [LeadinHelpDirective, LeadinHelpComponent, SpinnerComponent, PaginationComponent],
  entryComponents: []
})
export class SharedModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        UserService,
        AuthService,
        LogUpdateService,
        PromptUpdateService,
        CheckForUpdateService,
        TranslatorService,
        SidebarManagerService,
        TablesService
      ]
    };
  }

  static forChild(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        SidebarManagerService,
        TablesService
      ]
    };
  }
}
